/**
 * @description import svg content as inline resource with modifications applied
 * @param {string} xmlStr raw svg content
 * @param {Object} modifiers keys are tag names to be modified. values are attributeName:attributeValue to be applied. es: {path: {fill: 'salmon'}} applies fill="salmon" to every path element
 */
const svgload = (xmlStr, modifiers) => {
  const parser = new DOMParser()
  const dom = parser.parseFromString(xmlStr, 'application/xml')

  Object.entries(modifiers).forEach(([tag, tagModifiers]) => {
    const domEls = dom.getElementsByTagName(tag)

    Array.from(domEls).forEach(el => {
      Object.entries(tagModifiers).forEach(([attr, value]) =>
        el.setAttribute(attr, value)
      )
    })
  })

  const output = new XMLSerializer().serializeToString(dom)
  return `url("data:image/svg+xml;utf8,${encodeURIComponent(output)}")`
}

export default svgload
